module.exports = __webpack_public_path__ + "static/media/stree-shakti.a92f351b.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stree-shakti.JPG
// module id = 309
// module chunks = 0